export default __webpack_public_path__ + "static/media/quick-new-logo.561f0216.svg";